import api from './api'

export interface AuthenticatedUser {
  id: number
  username: string
  email: string | null
  discordId: string | null
  discordUsername: string | null
  discordGlobalName: string | null
  discordAvatar: string | null
  createdAt: string
  updatedAt: string
}

export function isAdminUser(user: AuthenticatedUser | null | undefined): boolean {
  if (!user) {
    return false
  }

  const candidates = [
    user.username,
    user.discordUsername,
    user.discordGlobalName,
  ]
    .filter(Boolean)
    .map(value => String(value).trim().toLowerCase())

  return candidates.includes('nostradamus') || candidates.includes('nostradamus11')
}

export async function fetchCurrentUser(): Promise<AuthenticatedUser | null> {
  try {
    const response = await api.get<{ authenticated: boolean; user: AuthenticatedUser }>('/auth/me')
    if (!response.data.authenticated) {
      return null
    }
    return response.data.user
  } catch (error: any) {
    if (error.response?.status === 401) {
      return null
    }
    throw error
  }
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout')
}




